import styled from 'styled-components';

export const Modal = styled.div`
  display: ${({ isOpen }) => !isOpen && 'none'};
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99;
  height: 100%;
  left: 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  padding: 5% 20%;
`;
